import React, { memo } from "react";
import {
	Row, Col,
	Card, CardBody,
	Button
} from "reactstrap";
import { NavLink } from "react-router-dom";

const TestStart = memo( function TestStart({ mockId }) {

	return (
		<div className="content questionsArea deviceTestPage">
			<Row>
				<Col xs={12}>
					<Card>
						<CardBody>
							<Row className='testFinish unselectable'>
								<div className="col-sm-12">
									<h4 className="mt-0">Test Pending</h4>
									<p>
										<span>
											This mock is not yet started. Click 
											<NavLink to={`/admin/fulltest/${mockId}/0`} >
												<button className="btn">Continue</button>
											</NavLink>
											{/* <a href={`/admin/fulltest/${mockId}/0`}>
												<button className="btn">Continue</button>
											</a>  */}
											to start this test.
										</span>
									</p>
								</div>
							</Row>
						</CardBody>
					</Card>
				</Col>
			</Row>
		</div>
	);
});

export default TestStart;